import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { RejectDialogComponent } from './components/reject-dialog/reject-dialog.component';
import { ContentPlaceholderAnimationComponent } from './content-placeholder-animation/content-placeholder-animation.component';
import { LayoutComponent } from './layout/layout.component';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';

import { YesNoPipe } from './pipes/yes-no.pipe';
import { SearchBoxComponent } from './search-box/search-box.component';
import { IndianCurrencyPipe } from './pipes/indianCurrency.pipe';
import { PaymentModeLabelPipe } from './pipes/paymentModeLabel.pipe';
import { MatSelectFilterModule } from 'mat-select-filter';
import { KeyboardNavigableDirective } from './directive/keyboardnavigable.directive';
import { CommonDrawerComponent } from './components/common-drawer/common-drawer.component';
import { CalculateAgePipe } from './pipes/calculate-age.pipe';
import { DoctorFilterComponent } from './tableFillters/doctor-filter/doctor-filter.component';
import { TableComponent } from './tables/table/table.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FormatTimeDirective } from './directive/app-format-time.directive';
import { TimeFormatPipe } from './pipes/app-time-format.pipe';
import { TreatmentsSelectPanelPipe } from './pipes/treatments-select-panel.pipe';
import { ProcessObservationComponent } from './components/process-observation/process-observation.component';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { ProcessMediaListComponent } from './components/process-media-list/process-media-list.component';

@NgModule({
  imports: [
    RouterModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule,
    MatSelectFilterModule,
    MatIconModule,
    MatChipsModule,

    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressBarModule,
  ],
  declarations: [
    ConfirmDialogComponent,
    RejectDialogComponent,
    ContentPlaceholderAnimationComponent,
    LimitToPipe,
    LocalDatePipe,
    YesNoPipe,
    IndianCurrencyPipe,
    PaymentModeLabelPipe,
    LayoutComponent,
    SearchBoxComponent,
    KeyboardNavigableDirective,
    CalculateAgePipe,
    DoctorFilterComponent,
    CommonDrawerComponent,
    TableComponent,
    FormatTimeDirective,
    TimeFormatPipe,
    TreatmentsSelectPanelPipe,
    ProcessObservationComponent,
    ProcessMediaListComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CustomMaterialModule,
    LimitToPipe,
    ConfirmDialogComponent,
    RejectDialogComponent,
    ContentPlaceholderAnimationComponent,
    LocalDatePipe,
    YesNoPipe,
    IndianCurrencyPipe,
    PaymentModeLabelPipe,
    TranslateModule,
    SearchBoxComponent,
    MatIconModule,
    KeyboardNavigableDirective,
    CalculateAgePipe,
    DoctorFilterComponent,
    CommonDrawerComponent,
    ProcessMediaListComponent,
    TableComponent,
    MatChipsModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressBarModule,
    FormatTimeDirective,
    TimeFormatPipe,
    TreatmentsSelectPanelPipe,
    ProcessObservationComponent,
  ],
})
export class SharedModule {
  private path = '/assets/images';
  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry
  ) {
    this.matIconRegistry.addSvgIcon(
      'edit',
      this.setPath(`${this.path}/edit.svg`)
    );
  }
  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
